import { render } from "./ViewHeadline.vue?vue&type=template&id=237ecbe8&scoped=true"
import script from "./ViewHeadline.vue?vue&type=script&lang=js"
export * from "./ViewHeadline.vue?vue&type=script&lang=js"

import "./ViewHeadline.vue?vue&type=style&index=0&id=237ecbe8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237ecbe8"]])

export default __exports__